import { render, staticRenderFns } from "./Sys_Set.vue?vue&type=template&id=2fc8fad8&scoped=true"
import script from "./Sys_Set.vue?vue&type=script&lang=js"
export * from "./Sys_Set.vue?vue&type=script&lang=js"
import style0 from "./Sys_Set.vue?vue&type=style&index=0&id=2fc8fad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc8fad8",
  null
  
)

export default component.exports